import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "../../../atom/Dropdown/Dropdown";

import styles from "./index.module.css";
import SpaceAddButton from "../SpaceAddButton";
import { CheckIcon } from "../../../../icons";
import SpaceDot from "../../../atom/Space/SpaceDot";
import { SpaceType } from "../../../../types/space";

interface SpaceDropdownProps {
  selectedValue?: string;
  spaceList: SpaceType[];
  onSelect: (value: string) => void;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onFocusClose: () => void;
}

const SpaceDropdown = ({
  selectedValue,
  spaceList,
  onSelect,
  open,
  onOpenChange,
  onFocusClose,
}: SpaceDropdownProps) => {
  const handleOpenChange = (isOpen: boolean) => {
    onOpenChange(isOpen);
  };

  if (!spaceList.length) return null;

  return (
    <DropdownMenu
      open={open}
      onOpenChange={handleOpenChange}
    >
      <DropdownMenuTrigger asChild>
        <SpaceAddButton
          color={spaceList.find((space) => space.id === Number(selectedValue))?.color}
        />
      </DropdownMenuTrigger>
      <DropdownMenuContent
        width="140px"
        sideOffset={5}
        align={"end"}
        side={"bottom"}
        onCloseAutoFocus={(e) => {
          e.preventDefault();
          onFocusClose();
        }}
      >
        <DropdownMenuRadioGroup
          value={selectedValue}
          onValueChange={onSelect}
          className={styles.radioGroup}
        >
          {spaceList.map((space) => (
            <DropdownMenuRadioItem
              key={space.id}
              value={space.id.toString()}
              className={styles.radioItem}
            >
              <SpaceDot color={space.color} />
              <div className={styles.itemContent}>{space.title}</div>
              {selectedValue === space.id.toString() && <CheckIcon />}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default SpaceDropdown;
